import React from 'react';
import { Icon } from '../../design/Icon';

const ALERT_CLASS = { info: '', error: 'alert-error', warning: 'alert-warning', success: 'alert-success' };
const ALERT_ICON = { info: 'info', error: 'alert', warning: 'alert', success: 'checkCircle' };

export function Alert({ tone = 'info', title, actions, icon, children }) {
  return (
    <div className={['alert', ALERT_CLASS[tone]].filter(Boolean).join(' ')} role={tone === 'error' ? 'alert' : 'status'}>
      <Icon name={icon || ALERT_ICON[tone]} />
      <div className="grow">
        {title && <div className="a-title">{title}</div>}
        {children && <div>{children}</div>}
      </div>
      {actions && <div className="a-acts">{actions}</div>}
    </div>
  );
}

export function Progress({ value, max = 100, label }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className="progress" role="progressbar" aria-valuemin={0} aria-valuemax={max} aria-valuenow={value} aria-label={label}>
      <span style={{ width: `${pct}%` }} />
    </div>
  );
}

// SLA meters always show the target tick (docs/design/README.md).
export function Meter({ value, target, max = 100, color, label, className = '' }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const fill = color || (target != null && value < target ? 'var(--critical-mark)' : 'var(--series-1)');
  return (
    <div className={`meter ${className}`.trim()} role="meter" aria-valuemin={0} aria-valuemax={max} aria-valuenow={value} aria-label={label}>
      <div className="fill" style={{ width: `${pct}%`, background: fill }} />
      {target != null && <div className="target" style={{ left: `${(target / max) * 100}%` }} title={`Target ${target}`} />}
    </div>
  );
}

export function Legend({ items }) {
  return (
    <div className="legend">
      {items.map((item) => (
        <span key={item.name}>
          <i
            className={item.line ? 'line' : ''}
            style={{
              background: item.dashed ? `repeating-linear-gradient(90deg,${item.color} 0 4px,transparent 4px 7px)` : item.color,
            }}
          />
          {item.name}
        </span>
      ))}
    </div>
  );
}
